export default __webpack_public_path__ + "static/media/layer01.4f8530bc.png";